import React, { useEffect, useState } from 'react';
import Drawer from '../../../../../component/Drawer';
import dateIcon from '../../../../../assets/image/date-schedule-icon.svg';
import pauseScheduleIcon from '../../../../../assets/image/pause-schedule-icon.svg';
import editIcon from '../../../../../assets/image/edit-icon.png';
import reportPdfIcon from '../../../../../assets/image/report-pdf-icon.svg';
import csvIcon from '../../../../../assets/image/csv-icon.svg';
import xlsIcon from '../../../../../assets/image/xls-icon.svg';
import arrowForwardIcon from '../../../../../assets/image/arrow-forward-icon.svg';
import arrowDownIcon from '../../../../../assets/image/arrow-down-gray-icon.svg';
import Button from '../../../../../component/ui/Button';
import {
	changeScheduleStatus,
	getScheduled,
	scheduleHistory,
} from '../../../../../services/reports';
import { capitalizeWords, formatAMPMDate } from '../../../../../utils/constant';
import { toast } from 'react-toastify';
import ScheduleHistory from './scheduleHistory';
import ScheduleActivity from './scheduleActivity';

export default function ReportScheduledDrawer({
	isOpen,
	onClose,
	id,
	getList,
	setIsScheduleModelOpen,
}) {
	const [activeTab, setActiveTab] = useState('Schedule History');
	const [isOpenRecipient, setIsOpenRecipient] = useState(false);
	const [loader, setLoader] = useState(false);
	const navTabs = ['Schedule History', 'Activity'];
	const [scheduleDetails, setScheduleDetails] = useState(null);
	const [scheduleHistoryList, setScheduleHistory] = useState([]);
	const [params, setParams] = useState({
		page: 1,
		limit: 100,
	});

	const renderTabContent = () => {
		switch (activeTab) {
			case 'Schedule History':
				return <ScheduleHistory list={scheduleHistoryList} />;
			case 'Activity':
				return <ScheduleActivity />;
			default:
				return null;
		}
	};

	const DetailRow = ({ label, value }) => (
		<div className="d-flex justify-content-start align-items-center gap-4 py-3">
			<div className="w-150 fs-4 fw-semibold">{label}</div>
			<div className="fs-4 fw-light">:</div>
			<div className="fs-4 fw-light">{value}</div>
		</div>
	);

	const getScheduleDetails = async () => {
		try {
			const { scheduled_report } = await getScheduled(id);
			if (scheduled_report) {
				setScheduleDetails(scheduled_report);
			}
		} catch (error) {}
	};

	const handleScheduleReport = async (type) => {
		try {
			setLoader(true);
			const res = await changeScheduleStatus(id, type);
			if (res.success) {
				toast.success(res.message);
				getScheduleDetails();
				getList();
			} else {
				toast.error(res.message || 'Something went wrong!');
			}
		} catch (error) {
		} finally {
			setLoader(false);
		}
	};

	const getScheduleHistoryList = async () => {
		try {
			const param = {
				...params,
				report_name: scheduleDetails.report_name,
			};
			const { logs } = await scheduleHistory(param);
			if (logs) {
				setScheduleHistory(logs);
			}
		} catch (error) {}
	};

	useEffect(() => {
		if (scheduleDetails && scheduleDetails.report_name) {
			getScheduleHistoryList();
		}
	}, [scheduleDetails]);

	useEffect(() => {
		if (id) {
			getScheduleDetails();
		}
	}, [id]);
	return (
		scheduleDetails && (
			<Drawer
				handleViewMoreDetails={''}
				isOpen={isOpen}
				onClose={onClose}
				status={scheduleDetails.status === 'active' ? 'Active' : ''}
				title={'Scheduled Report'}
			>
				<br />
				<div>
					<div
						className="d-flex justify-content-start align-items-start p-3 gap-4 rounded"
						style={{ background: '#F6F6F9', boxShadow: '0px 3px 8px 0px rgba(0, 0, 0, 0.05)' }}
					>
						<img
							width={40}
							height={40}
							src={scheduleDetails.status === 'active' ? dateIcon : pauseScheduleIcon}
							alt="date-icon"
						/>
						<div className="align-items-start">
							<div className="fs-4 fw-light">
								{scheduleDetails.status === 'active'
									? 'The next schedule report will be sent on '
									: 'The report’s scheduler is currently paused.'}
							</div>
							<div className="fs-4 fw-light mt-1 mb-3">
								{scheduleDetails.status === 'active'
									? scheduleDetails.next_run_at !== null && scheduleDetails.next_run_at !== ''
										? formatAMPMDate(scheduleDetails.next_run_at)
										: ''
									: 'Kindly resume it to s=continue scheduling.'}
							</div>
							<div className="d-flex justify-content-start">
								<Button
									type="button"
									loader={loader}
									disabled={loader}
									className="mt-0 btn btn-gray"
									button={
										scheduleDetails.status === 'active' ? 'Pause Schedule' : 'Resume Schedule'
									}
									onClick={() => {
										handleScheduleReport(scheduleDetails.status === 'active' ? 'pause' : 'resume');
									}}
								/>
							</div>
						</div>
					</div>
					<br />
					<hr />
					<div className="d-flex justify-content-start align-items-center gap-4">
						<div className="fs-4 fw-bold text-dark">Schedule Details</div>
						<img
							width={20}
							height={20}
							src={editIcon}
							className="cursor-pointer"
							alt="edit-icon"
							onClick={() => {
								onClose();
								setIsScheduleModelOpen(true);
							}}
						/>
						<div
							className="fs-5 fw-bold text-dark cursor-pointer"
							onClick={() => {
								onClose();
								setIsScheduleModelOpen(true);
							}}
						>
							Edit
						</div>
					</div>
					<hr />
					<DetailRow
						label="Frequency"
						value={capitalizeWords(scheduleDetails.frequency)}
					/>
					<DetailRow
						label="Start Date"
						value={
							scheduleDetails.start_date !== null && scheduleDetails.start_date !== ''
								? formatAMPMDate(scheduleDetails.start_date)
								: ''
						}
					/>
					<div className="d-flex justify-content-start align-items-center gap-4 py-3">
						<div className="w-150 fs-4 fw-semibold">Format</div>
						<div className="fs-4 fw-light">:</div>
						<img
							width={20}
							height={20}
							src={
								scheduleDetails.file_format === 'pdf'
									? reportPdfIcon
									: scheduleDetails.file_format === 'csv'
										? csvIcon
										: xlsIcon
							}
							alt="format-icon"
						/>
						<div className=" fs-4 fw-light">{scheduleDetails.file_format.toUpperCase()}</div>
					</div>
					<div
						className="d-flex justify-content-start align-items-center gap-4 py-3 cursor-pointer"
						onClick={() => setIsOpenRecipient(!isOpenRecipient)}
					>
						<div className="fs-4 fw-semibold">Show Recipients</div>
						<img
							width={12}
							height={12}
							src={isOpenRecipient ? arrowDownIcon : arrowForwardIcon}
							alt="arrow-icon"
						/>
					</div>
					{isOpenRecipient && (
						<div className="fs-5 fw-semibold text-black">
							<div>{scheduleDetails.primary_email}</div>

							{scheduleDetails.additional_recipients?.length > 0 &&
								scheduleDetails.additional_recipients.map((email, index) => (
									<div key={index}>{email}</div>
								))}
						</div>
					)}
					<br />
					<hr />

					{/* tabs  */}
					<div>
						<ul className="nav mb-4 mt-2">
							{navTabs.map((item, index) => (
								<li
									key={index}
									className="nav-item"
								>
									<div
										className={`nav-link ${activeTab === item && 'active'} cursor-pointer`}
										onClick={(e) => {
											e.preventDefault();
											setActiveTab(item);
										}}
									>
										{item}
									</div>
								</li>
							))}
						</ul>
						<hr
							style={{
								backgroundColor: '#E3E4E5',
								boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
								marginTop: '-5px',
							}}
						/>
						<div>{renderTabContent()}</div>
					</div>
				</div>
			</Drawer>
		)
	);
}
